var map = {
	"./partners1.png": 91127,
	"./partners10.png": 27643,
	"./partners11.png": 41767,
	"./partners12.png": 29638,
	"./partners13.png": 47700,
	"./partners14.png": 72753,
	"./partners15.png": 83833,
	"./partners16.png": 18255,
	"./partners17.png": 66893,
	"./partners18.png": 33438,
	"./partners19.png": 10460,
	"./partners2.png": 32221,
	"./partners20.png": 32948,
	"./partners21.png": 59545,
	"./partners22.png": 78454,
	"./partners23.png": 56430,
	"./partners24.png": 82684,
	"./partners25.png": 45363,
	"./partners26.png": 484,
	"./partners27.png": 72705,
	"./partners28.png": 56842,
	"./partners29.png": 89334,
	"./partners3.png": 26043,
	"./partners30.png": 19066,
	"./partners31.png": 10185,
	"./partners32.png": 45481,
	"./partners33.png": 58086,
	"./partners34.png": 18636,
	"./partners35.png": 77698,
	"./partners4.png": 21944,
	"./partners5.png": 73658,
	"./partners6.png": 93934,
	"./partners7.png": 13404,
	"./partners8.png": 20071,
	"./partners9.png": 25169,
	"./partners_bg.png": 3100
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 38083;